import { render, staticRenderFns } from "./client-download.vue?vue&type=template&id=3b833c6b&scoped=true"
import script from "./client-download.vue?vue&type=script&lang=js"
export * from "./client-download.vue?vue&type=script&lang=js"
import style0 from "./client-download.vue?vue&type=style&index=0&id=3b833c6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b833c6b",
  null
  
)

export default component.exports